

import React from 'react';
import { Bar } from 'react-chartjs-2';
import { useTheme } from '@mui/material/styles';
import { useIntl } from 'react-intl';

const capitalize = str =>
    typeof str === 'string' && str.length > 0
        ? str.charAt(0).toUpperCase() + str.slice(1)
        : '';

const UserNeedScores = ({ scores }) => {
    const intl = useIntl();
    const theme = useTheme();

    if (!scores || Object.keys(scores).length === 0) {
        return null;
    }

    const entries = Object.entries(scores).sort((a, b) => b[1] - a[1]); // Descending

    const labels = entries.map(([key]) => `"${capitalize(key)}"`);
    const values = entries.map(([, value]) => value);

    const chartData = {
        labels,
        datasets: [
            {
                label: intl.formatMessage({ id: "article.userneed.scoring.value.label" }),
                data: values,
                backgroundColor: theme.palette.primary.main,
            },
        ],
    };

    const chartOptions = {
        responsive: true,
        plugins: {
            legend: {
                display: false,
            },
            /*title: {
                display: true,
                text: 'Tarvejakauma', // Your title here
                font: {
                    size: 18,
                    weight: 'bold',
                },
                padding: {
                    top: 10,
                    bottom: 30,
                },
            },*/
        },
        scales: {
            x: {
                grid: {
                    display: false, // Removes vertical grid lines
                },
            },
            y: {
                grid: {
                    display: false, // Removes horizontal grid lines
                },
                ticks: {
                    callback: (value) => `${value} %`, // Append "%" unit
                },
            },
        },
    };

    return <Bar data={chartData} options={chartOptions} />;
};

export default UserNeedScores;